<script>
import { Doughnut } from "vue-chartjs";

export default {
    name: "DoughnutChart",
    extends: Doughnut,
    props: {
        title: {
            type: String,
            default: null,
        },
        labels: {
            type: Array,
            default: () => [],
        },
        datasets: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        data(vm = this) {
            return {
                labels: vm.labels,
                datasets: vm.datasets,
            };
        },
        options(vm = this) {
            return {
                responsive: true,
                maintainAspectRatio: false,
                cutoutPercentage: 80,
                legend: {
                    display: false,
                },
                title: {
                    display: !!vm.title,
                    text: vm.title
                },
                layout: {
                    padding: {
                        //
                    }
                },
            };
        }
    },
    mounted() {
        const vm = this;
        vm.renderChart(vm.data, vm.options);
    },
    watch: {
        data() {
            const vm = this;
            vm.renderChart(vm.data, vm.options);
        },
        options() {
            const vm = this;
            vm.renderChart(vm.data, vm.options);
        }
    }
};
</script>
